
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
	import IResource from "@/IResource";
	import FloatingBottomBar from '@/components/reservation/FloatingBottomBar.vue';
	import { IAvailabilityValue } from '@/IAvailability';

	@Component({
		components: {}
	})
	export default class DayOverview extends Vue {

		@Prop({
			required: true,
			type: Date
		})
		public selectedDate!: Date | null;

		public showDetails: {[index: number]: boolean} = {};

		get availability(): IAvailabilityValue[] | null {
			if (!this.$store.state.availability[this.selectedDateKey]) {
				return null;
			}
			return this.$store.state.availability[this.selectedDateKey].sort((a: IAvailabilityValue, b: IAvailabilityValue) => a[0] - b[0]);
		}

		get selectedDateKey(): string {
			if (!this.selectedDate) {
				return '';
			}
			let d = this.selectedDate;
			return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
		}

		public formatTime(minutes: number): string {
			let mins: number|string = minutes % 60;
			if (mins < 10) {
				mins = "0" + mins;
			}
			let hours: number|string = Math.floor(minutes / 60);
			if (hours < 10) {
				hours = "0" + hours;
			}
			return hours + ':' + mins;
		}

		public toggleDetails(index: number) {
			this.$set(this.showDetails, index, !this.showDetails[index]);
		}
	}
